(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Hype Discount Toggle Module
   * Optimized for performance with shared utilities
   */
  (function HypeDiscountToggle() {
    'use strict';
    
    const CONFIG = {
      STORAGE_KEY: 'hype-discount-codes',
      IGNORE_PARAM: 'from-hype',
      SELECTORS: {
        wrapper: '[data-hype-discount-toggle-wrapper]',
        toggle: '[data-hype-discount-toggle]',
        status: '[data-hype-discount-status]',
        statusText: '[data-status-text]'
      },
      EVENTS: {
        apply: 'hype:apply-discount',
        clear: 'hype:clear-discount',
        refresh: 'hype:refresh',
        uiRefresh: 'hype:ui:refresh'
      }
    };

    // Shared utility functions (defined once, reused across all toggles)
    const getShopifyRoot = () => window.Shopify?.routes?.root || '/';
    
    const buildFormData = (updates) => {
      const formData = new FormData();
      Object.entries(updates).forEach(([key, value]) => {
        if (key === 'attributes') {
          Object.entries(value).forEach(([attrKey, attrValue]) => {
            formData.append(`attributes[${attrKey}]`, String(attrValue));
          });
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    };

    const updateCart = async (updates) => {
      const url = new URL(`${getShopifyRoot()}cart/update.js`, window.location.origin);
      url.searchParams.set(CONFIG.IGNORE_PARAM, '1');
      
      const response = await fetch(url, { 
        method: 'POST', 
        body: buildFormData(updates)
      });

      if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
      return response.json();
    };

    const dispatchEvents = (eventType, detail) => {
      document.dispatchEvent(new CustomEvent(eventType, { detail }));
    };

    const triggerHypeRefresh = (detail = {}) => {
      const eventDetail = { source: 'collection-toggle', ...detail };
      [CONFIG.EVENTS.refresh, CONFIG.EVENTS.uiRefresh].forEach(event => 
        dispatchEvents(event, eventDetail)
      );
    };

    // Storage helpers (defined once, minimal overhead)
    const getStoredCodes = () => {
      try {
        const stored = sessionStorage.getItem(CONFIG.STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        return [];
      }
    };

    const updateStoredCodes = (code, shouldAdd) => {
      try {
        const codes = getStoredCodes();
        const newCodes = shouldAdd 
          ? (codes.includes(code) ? codes : [...codes, code])
          : codes.filter(c => c !== code);
        
        newCodes.length > 0 
          ? sessionStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(newCodes))
          : sessionStorage.removeItem(CONFIG.STORAGE_KEY);
      } catch (e) {
        console.warn('Failed to update discount codes:', e);
      }
    };

    // Toggle setup (only called once per toggle element)
    function setupToggle(wrapper) {
      if (!wrapper || wrapper.dataset.hypeToggleInitialized === 'true') return;

      const toggleInput = wrapper.querySelector(CONFIG.SELECTORS.toggle);
      const statusEl = wrapper.querySelector(CONFIG.SELECTORS.status);
      const discountCode = wrapper.dataset.hypeDiscountCode;

      if (!toggleInput || !discountCode) return;

      let enabled = getStoredCodes().includes(discountCode);
      let busy = false;

      const updateUI = () => {
        toggleInput.setAttribute('aria-checked', String(enabled));
        toggleInput.checked = enabled;
        wrapper.dataset.hypeDiscountActive = String(enabled);
        
        const statusText = statusEl?.querySelector(CONFIG.SELECTORS.statusText);
        if (statusText) {
          statusText.textContent = enabled ? 'Discount Active' : 'Discount Inactive';
        }
      };

      const setBusy = (state) => {
        busy = state;
        toggleInput.disabled = state;
      };

      const toggleDiscount = async (shouldEnable) => {
        const cartUpdates = shouldEnable
          ? { discount: discountCode, attributes: { _hype_link: discountCode } }
          : { discount: '', attributes: { _hype_link: '' } };

        await updateCart(cartUpdates);
        updateStoredCodes(discountCode, shouldEnable);
        
        dispatchEvents(
          shouldEnable ? CONFIG.EVENTS.apply : CONFIG.EVENTS.clear,
          { code: discountCode, source: 'collection-toggle', enabled: shouldEnable }
        );
        
        triggerHypeRefresh({ code: discountCode, enabled: shouldEnable });
        
        await new Promise(resolve => setTimeout(resolve, 100));
        window.location.reload();
      };

      toggleInput.addEventListener('change', async () => {
        if (busy) return;

        enabled = toggleInput.checked;
        setBusy(true);
        updateUI();

        try {
          await toggleDiscount(enabled);
        } catch (error) {
          console.error('Toggle failed:', error);
          enabled = !enabled;
          updateUI();
        } finally {
          setBusy(false);
        }
      });

      updateUI();
      wrapper.dataset.hypeToggleInitialized = 'true';
    }

    // Initialize all toggles (runs once on page load)
    const init = () => {
      const toggles = document.querySelectorAll(CONFIG.SELECTORS.wrapper);
      if (toggles.length === 0) return;
      toggles.forEach(setupToggle);
    };

    document.readyState === 'loading' 
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discount-types-features"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-offer-library]').forEach((library) => {
    const tabs = Array.from(library.querySelectorAll('[data-offer-tab]'));
    const panels = Array.from(library.querySelectorAll('[data-offer-panel]'));

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activateTab(tabs[nextIndex], true);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    const updateBackToTop = () => backToTop.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    updateBackToTop();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const header = document.getElementById('site-header');
  const megaMenus = header?.querySelectorAll('[data-mega-nav]') || [];
  const closeMegaMenus = (exception) => {
    megaMenus.forEach((menu) => {
      if (menu !== exception) {
        menu.classList.remove('is-open');
        menu.querySelector('button')?.setAttribute('aria-expanded', 'false');
      }
    });
  };

  megaMenus.forEach((menu) => {
    const trigger = menu.querySelector('button');
    trigger?.addEventListener('click', () => {
      const willOpen = !menu.classList.contains('is-open');
      closeMegaMenus(menu);
      menu.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', String(willOpen));
    });
  });

  document.addEventListener('click', (event) => {
    if (!header?.contains(event.target)) closeMegaMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegaMenus();
  });

  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const setMobileMenu = (open) => {
    mobileToggle?.setAttribute('aria-expanded', String(open));
    mobileMenu?.setAttribute('aria-hidden', String(!open));
    mobileMenu?.classList.toggle('is-open', open);
    mobileOverlay?.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };
  mobileToggle?.addEventListener('click', () => setMobileMenu(mobileToggle.getAttribute('aria-expanded') !== 'true'));
  mobileOverlay?.addEventListener('click', () => setMobileMenu(false));
  mobileMenu?.querySelector('[data-mobile-close]')?.addEventListener('click', () => setMobileMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMobileMenu(false);
  });

  const cartToggle = document.getElementById('cart-toggle');
  const cartCount = document.getElementById('cart-count');
  const updateCartCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) return;
      const cart = await response.json();
      if (!cartCount) return;
      cartCount.textContent = cart.item_count > 9 ? '9+' : cart.item_count;
      cartCount.hidden = cart.item_count === 0;
    } catch (error) {}
  };
  cartToggle?.addEventListener('click', () => document.dispatchEvent(new CustomEvent('astral-open-cart')));
  document.addEventListener('astral-cart-updated', updateCartCount);
  updateCartCount();

  } catch(e) { console.error(e); }
})();
})();
